// extracted by mini-css-extract-plugin
module.exports = {"container":"Transfer_container__2zBEG","left":"Transfer_left__3kL-5","right":"Transfer_right__hr4S7"};